/** @jsxImportSource react */
import { useRef, useState } from 'react'
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Stack, Switch, TextField } from '@mui/material'
import { getErrorMessage } from '../../utils/apiErrors'

/** Name + visibility for a new view (or a renamed existing one). */
const SaveViewDialog = ({ open, initialName = '', initialShared = false, canShare, title, busy, error, onSave, onClose }) => {
  const [name, setName] = useState(initialName)
  const [shared, setShared] = useState(initialShared)
  const nameRef = useRef(null)

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
      // focus explicitly once open: autoFocus loses to the menu that opened this dialog closing
      TransitionProps={{ onEnter: () => { setName(initialName); setShared(initialShared) }, onEntered: () => nameRef.current?.select() }}
      PaperProps={{ component: 'form', onSubmit: (e) => { e.preventDefault(); onSave({ name: name.trim(), shared }) } }}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {error && <Alert severity="error">{getErrorMessage(error)}</Alert>}
          <TextField label="View name" required inputRef={nameRef} value={name} onChange={(e) => setName(e.target.value)} inputProps={{ maxLength: 100 }} />
          <FormControlLabel
            control={<Switch checked={shared} onChange={(e) => setShared(e.target.checked)} disabled={!canShare} />}
            label={canShare ? 'Share with everyone in this workspace' : 'Only admins can share views'}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" variant="contained" disabled={busy || !name.trim()}>Save</Button>
      </DialogActions>
    </Dialog>
  )
}

export default SaveViewDialog
